import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Stack, Tooltip } from '@mui/material';
import { styled } from '@mui/styles';
import React from 'react';

import WsColors from '../../WsColors';
import { WsTypography, WsTypoColors } from '../WsTypography';

export const StatusIcon = styled(FiberManualRecordIcon)(() => ({
  height: '12px',
  width: '12px',
}));
export enum WsDotColors {
  RED = 'red',
  GREEN = 'green',
  YELLOW = 'yellow',
  SENARY = 'senary',
  BLUE = 'blue',
  BLACK = 'black',
  WHITE = 'white',
}
const mapColor = new Map();
mapColor.set('red', WsColors.Red500);
mapColor.set('green', WsColors.Green500);
mapColor.set('yellow', WsColors.Yellow500);
mapColor.set('senary', WsColors.TertiaryShades800);
mapColor.set('blue', WsColors.TheBlues300);
mapColor.set('black', WsColors.GenericRichBlack);
mapColor.set('white', WsColors.White);

export enum WsDotTextColors {
  SECONDARY = 'secondary',
  BLACK = 'black',
  GREEN = 'green',
  SENARY = 'senary',
  WHITE = 'white',
}

const mapTextColor = new Map();
mapTextColor.set('secondary', WsTypoColors.SECONDARY);
mapTextColor.set('black', WsTypoColors.BLACK);
mapTextColor.set('green', WsTypoColors.GREEN);
mapTextColor.set('senary', WsTypoColors.SENARY);
mapTextColor.set('white', WsTypoColors.WHITE);

export interface IWsDotIcon {
  color: WsDotColors;
  value: number | string;
  textColor?: WsDotTextColors;
  popOverText?: string;
}

const WsDotIcon: React.FC<IWsDotIcon> = ({ color, value, textColor, popOverText }) => (
  <Tooltip title={popOverText ?? ''} placement="top">
    <Stack direction={'row'} spacing={0.5} alignItems={'center'}>
      <StatusIcon fontSize="small" sx={{ color: mapColor.get(color) }} />
      <WsTypography color={mapTextColor.get(textColor)} display="block" cursor="pointer">
        {value}
      </WsTypography>
    </Stack>
  </Tooltip>
);

export default WsDotIcon;
